/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscountTypeEnum } from './DiscountTypeEnum';
import {
    DiscountTypeEnumFromJSON,
    DiscountTypeEnumFromJSONTyped,
    DiscountTypeEnumToJSON,
    DiscountTypeEnumToJSONTyped,
} from './DiscountTypeEnum';

/**
 * 
 * @export
 * @interface UpdateOfferProduct
 */
export interface UpdateOfferProduct {
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferProduct
     */
    productOfferId: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferProduct
     */
    productId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOfferProduct
     */
    isTransfer: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferProduct
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferProduct
     */
    discount: number;
    /**
     * 
     * @type {DiscountTypeEnum}
     * @memberof UpdateOfferProduct
     */
    discountType: DiscountTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateOfferProduct
     */
    timeDiscounts: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferProduct
     */
    firstPayment: number;
}



/**
 * Check if a given object implements the UpdateOfferProduct interface.
 */
export function instanceOfUpdateOfferProduct(value: object): value is UpdateOfferProduct {
    if (!('productOfferId' in value) || value['productOfferId'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('isTransfer' in value) || value['isTransfer'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('discountType' in value) || value['discountType'] === undefined) return false;
    if (!('timeDiscounts' in value) || value['timeDiscounts'] === undefined) return false;
    if (!('firstPayment' in value) || value['firstPayment'] === undefined) return false;
    return true;
}

export function UpdateOfferProductFromJSON(json: any): UpdateOfferProduct {
    return UpdateOfferProductFromJSONTyped(json, false);
}

export function UpdateOfferProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOfferProduct {
    if (json == null) {
        return json;
    }
    return {
        
        'productOfferId': json['productOfferId'],
        'productId': json['productId'],
        'isTransfer': json['isTransfer'],
        'quantity': json['quantity'],
        'discount': json['discount'],
        'discountType': DiscountTypeEnumFromJSON(json['discountType']),
        'timeDiscounts': json['timeDiscounts'],
        'firstPayment': json['firstPayment'],
    };
}

export function UpdateOfferProductToJSON(json: any): UpdateOfferProduct {
    return UpdateOfferProductToJSONTyped(json, false);
}

export function UpdateOfferProductToJSONTyped(value?: UpdateOfferProduct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productOfferId': value['productOfferId'],
        'productId': value['productId'],
        'isTransfer': value['isTransfer'],
        'quantity': value['quantity'],
        'discount': value['discount'],
        'discountType': DiscountTypeEnumToJSON(value['discountType']),
        'timeDiscounts': value['timeDiscounts'],
        'firstPayment': value['firstPayment'],
    };
}

